// extracted by mini-css-extract-plugin
export default {"subheading":"LegalImprint_subheading__FAAse","text":"LegalImprint_text__7kRNs","footer":"LegalImprint_footer__L5lSS","link":"LegalImprint_link__sbnfQ"};